// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5 22V17M5 7V2M2.5 4.5H7.5M2.5 19.5H7.5M13.5 3L11.7658 7.50886C11.4838 8.24209 11.3428 8.60871 11.1235 8.91709C10.9292 9.1904 10.6904 9.42919 10.4171 9.62353C10.1087 9.84281 9.74209 9.98381 9.00886 10.2658L4.5 12L9.00886 13.7342C9.74209 14.0162 10.1087 14.1572 10.4171 14.3765C10.6904 14.5708 10.9292 14.8096 11.1235 15.0829C11.3428 15.3913 11.4838 15.7579 11.7658 16.4911L13.5 21L15.2342 16.4911C15.5162 15.7579 15.6572 15.3913 15.8765 15.0829C16.0708 14.8096 16.3096 14.5708 16.5829 14.3765C16.8913 14.1572 17.2579 14.0162 17.9911 13.7342L22.5 12L17.9911 10.2658C17.2579 9.98381 16.8913 9.8428 16.5829 9.62353C16.3096 9.42919 16.0708 9.1904 15.8765 8.91709C15.6572 8.60871 15.5162 8.24209 15.2342 7.50886L13.5 3Z"
    />
  </svg>
);
const IconAiSpecial = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconAiSpecial;
